import type { CareerHistoryEntry, CareerHistoryList } from "@evolua/api-client";

const ANA = "11111111-1111-4111-8111-111111111111";

const STORE: Array<CareerHistoryEntry & { employeeId: string; rawSalary?: number }> = [
  {
    id: crypto.randomUUID(),
    employeeId: ANA,
    occurredAt: "2024-01-15T12:00:00.000Z",
    changeType: "status",
    fromLabel: null,
    toLabel: "ACTIVE",
    salaryAmount: null,
    salaryRedacted: false,
    source: "sync.initial",
  },
  {
    id: crypto.randomUUID(),
    employeeId: ANA,
    occurredAt: "2024-06-01T12:00:00.000Z",
    changeType: "department",
    fromLabel: "Operações",
    toLabel: "RH",
    salaryAmount: null,
    salaryRedacted: false,
    source: "sync.incremental",
  },
  {
    id: crypto.randomUUID(),
    employeeId: ANA,
    occurredAt: "2025-03-01T12:00:00.000Z",
    changeType: "position",
    fromLabel: "Assistente",
    toLabel: "Analista",
    salaryAmount: null,
    salaryRedacted: false,
    source: "sync.incremental",
  },
  {
    id: crypto.randomUUID(),
    employeeId: ANA,
    occurredAt: "2025-09-01T12:00:00.000Z",
    changeType: "salary",
    fromLabel: "4200",
    toLabel: "4800",
    salaryAmount: 4800,
    salaryRedacted: false,
    source: "sync.incremental",
    rawSalary: 4800,
  },
  {
    id: crypto.randomUUID(),
    employeeId: ANA,
    occurredAt: "2026-01-10T12:00:00.000Z",
    changeType: "manager",
    fromLabel: "Elena Rocha",
    toLabel: "Bruno Costa",
    salaryAmount: null,
    salaryRedacted: false,
    source: "sync.incremental",
  },
];

export function listDemoCareerHistory(
  employeeId: string,
  canSeeSalary: boolean,
): CareerHistoryList {
  const data = STORE.filter((e) => e.employeeId === employeeId)
    .sort((a, b) => b.occurredAt.localeCompare(a.occurredAt))
    .map((e) => {
      if (e.changeType !== "salary" || canSeeSalary) {
        return {
          id: e.id,
          occurredAt: e.occurredAt,
          changeType: e.changeType,
          fromLabel: e.fromLabel,
          toLabel: e.toLabel,
          salaryAmount: e.salaryAmount,
          salaryRedacted: false,
          source: e.source,
        };
      }
      return {
        id: e.id,
        occurredAt: e.occurredAt,
        changeType: e.changeType,
        fromLabel: "[REDACTED]",
        toLabel: "[REDACTED]",
        salaryAmount: null,
        salaryRedacted: true,
        source: e.source,
      };
    });
  return { data, total: data.length };
}
